exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".customer-edit-quotations__topbar{padding-top:20px;padding-bottom:20px;border-bottom:3px solid var(--theme-grey-bg)}", ""]);

// exports
